import { useSelector } from 'react-redux';
import { usePermissions } from '@Context';

export const useMenu = () => {
    const betaFeatures = useSelector(state => state.auth.betaFeatures);

    const {
        haveAccessToScorecardsPage,
        haveAccessToClausesPage,
        haveAccessToContractsPage
    } = usePermissions();

    return {
        topMenu: [
            {
                name: 'Scorecards',
                to: 'scorecards',
                show: haveAccessToScorecardsPage,
                description: 'Analyze and score risk from agreements.'
            },
            {
                name: 'Labels',
                to: 'labels',
                show: true,
                description: 'View and filter all labels saved on document.'
            },
            {
                name: 'Clauses',
                to: 'clauses',
                show: haveAccessToClausesPage,
                description: 'Browse clauses library and use in document.'
            },
            {
                name: 'Contracts',
                to: 'contracts',
                show: haveAccessToContractsPage,
                description: 'Search, view and download contracts.'
            },
            {
                name: 'Markup',
                to: 'markup',
                show: betaFeatures.includes('markup'),
                description: 'Highlight identified risk in document.'
            }
        ],
        bottomMenu: [
            { name: 'Settings', to: 'settings', show: true },
            { name: 'Copy support log', to: '', show: true },
            { name: 'Logout', to: '', show: true }
        ]
    };
};
